export default {"src":"/_next/static/media/CeliacDisease.2f7ea45d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};